module.exports = __webpack_public_path__ + "static/media/attachment-2.8908dd30.jpg";